<template>
  <div class="pingjia_body">
    <div style="width: 100%;"><img style="width: 100%;height: 200px" :src="list.covermap"></div>
    <div class="biaoti">{{list.titles}}</div>
    <div class="pinglun">
      <div style="height: 40px;line-height: 40px;">
        <span style="font-size: 14px">描述相符</span>
        <van-rate  v-model="value"/>
      </div>
      <div>
        <van-field
          v-model="message"
          rows="2"
          autosize
          label="评价"
          type="textarea"
          maxlength="50"
          placeholder="请输入评价内容"
          show-word-limit
        />
      </div>
    </div>
    <div style="width: 80%;margin: 10px auto;">
      <van-button @click="fabu" type="primary" size="large">发布</van-button>
    </div>
  </div>
</template>

<script>
    import {Toast} from 'vant';
    export default {
        name: "pingjia",
        data() {
            return {
                message: '',
                value: 1,
                list:[]
            }
        },
        created() {
            this.getdata()
        },
        methods: {
            fabu(){
                this.myrequest({
                    url: '/client/addcomment.action',
                    types: 'post',
                    data: {
                        orderid:this.$route.query.id,
                        star:this.value,
                        contents:this.message
                    },
                    succ: (res) => {
                        Toast.success('评价成功');
                        this.$router.go(-1)
                    },
                    errs: (msg) => {
                        Toast.fail(msg);
                    }
                })
            },
            getdata() {
                this.myrequest({
                    url: '/client/getoderlist.action',
                    types: 'get',
                    data: {
                        // token:this.$store.state.token
                        orderstatus: 1
                    },
                    succ: (res) => {
                        this.list = res.data[0]
                        console.log(this.active, 1212)
                    },
                    errs: (msg) => {

                    }
                })
            },
        }
    }
</script>

<style scoped lang="stylus">
  .pingjia_body {
    width 100%;
    background-color #f0f0f0;
    height 100%;
    position absolute;
    .pinglun{
      width 90%;
      margin auto
    }
    .biaoti{
      width 90%;
      margin 10px auto;
      font-weight 500;
      font-size 16px;
      color #333333
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/wode/pingjia.vue